import { gql } from '@apollo/client'

export const AUTH_CHANGE_PASSWORD = gql`
  mutation AuthChangePassword($input: AuthChangePasswordInput!, $action: ActionInput!) {
    authChangePassword(input: $input, action: $action) {
      message
    }
  }
`
